import styled from 'styled-components';

import { theme } from '../../../../styles';

export const StyledAttrbCount = styled.span`
  font-size: ${theme.fontSize.small};
`;
